import React from 'react'
import { Link } from 'react-router-dom'
import VideoModal from '../ModalVideo/VideoModal'
import { useLanguage } from '../../context/LanguageContext';

import image from '../../images/about.png'
import icon from '../../images/ab-icon.png'
import paws1 from '../..//images/paws-6.png'
import paws2 from '../..//images/paws-7.png'

const About = (props) => {
    const { t } = useLanguage();

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className={"" + props.hclass}>
            <div className="wraper">
                <div className="left">
                    <div className="image">
                        <img src={image} alt="Evcil Hayvan Gıda Takviyeleri" />
                        <div className="shape">
                            <svg width="793" height="786" viewBox="0 0 793 786" fill="none">
                                <path
                                    d="M84.9007 505.664C-181.681 609.802 245.585 843.801 512.633 772.246C713.751 718.356 833.104 511.631 779.214 310.513C725.325 109.395 552.6 -41.9576 351.482 11.9319C150.364 65.8214 351.482 401.526 84.9007 505.664Z"
                                    fill="#FFEFEB" />
                            </svg>
                        </div>
                    </div>
                    <div className="about-video">
                        <div className="icon">
                            <img src={icon} alt="VitAnimal İkon" />
                        </div>
                        <h2>{t('about.badgeTitle')}</h2>
                        <p>{t('about.badgeText')}</p>
                    </div>
                </div>
                <div className="right">
                    <span>{t('about.subtitle')}</span>
                    <h2>{t('about.title')}</h2>
                    <p>{t('about.p1')}</p>
                    <p>{t('about.p2')}</p>
                    <p>{t('about.p3')}</p>
                    <p>{t('about.p4')}</p>
                </div>
            </div>
            <div className="shape">
                <img src={paws1} alt="Kedi Pati İzi" />
            </div>
            <div className="shape-2">
                <img src={paws2} alt="Köpek Pati İzi" />
            </div>
        </section>
    )
}

export default About;
